import { render, staticRenderFns } from "./TemplatePicker.vue?vue&type=template&id=d063f2b2&scoped=true"
import script from "./TemplatePicker.vue?vue&type=script&lang=ts"
export * from "./TemplatePicker.vue?vue&type=script&lang=ts"
import style0 from "./TemplatePicker.vue?vue&type=style&index=0&id=d063f2b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d063f2b2",
  null
  
)

export default component.exports